/* eslint-disable @angular-eslint/no-output-rename */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FinancialPlanningService, FPGroupRow, GroupKey } from '../services/financial-planning.service';
import { GLReportingGroup } from 'src/app/client-api.service';
import { TableButton, TableClickEvent, TableColumn } from 'src/app/shared/tcc-ui/tables';

@Component({
  selector: 'app-financial-planning-lists',
  templateUrl: './financial-planning-lists.component.html',
  styleUrls: ['./financial-planning-lists.component.scss']
})
export class FinancialPlanningListsComponent implements OnInit {

  @Input() fpGroupRows: FPGroupRow[] | undefined;

  @Output('cloneGroupKey') cloneGroupKey: EventEmitter<any> = new EventEmitter();
  @Output('deleteGroupKey') deleteGroupKey: EventEmitter<any> = new EventEmitter();
  @Output('refreshGroupKey') refreshGroupKey: EventEmitter<any> = new EventEmitter();

reportingGroups: GLReportingGroup[] = [];
state: 'initializing' | 'loading' | 'ready' | 'processing' | undefined;
fpGroupColumns: TableColumn<FPGroupRow>[];
fpRequestsButtons: TableButton<any>[] | undefined;
currentGroupKeySelected: TableClickEvent<FPGroupRow> | undefined;
showAddGroupKeyTable = false;

constructor(private financialPlanningService: FinancialPlanningService) {
  this.fpGroupColumns = [
    { title: 'Group Key', name: 'groupKey', externalKey: 'groupKey', sort: true },
    { title: 'Name', name: 'name', externalKey: 'name', sort: true }
  ];

  this.fpRequestsButtons = [
    {
      data: 'editGroupKey',
      iconClass: 'fas fa-pencil-alt',
      hidden: false,
      buttonClass: 'btn btn-sm px-1 py-0 btn-outline-primary border-0',
      tooltip: 'Edit Reporting Group'
    },
    {
      data: 'cloneGroupKey',
      iconClass: 'fas fa-clone',
      hidden: false,
      buttonClass: 'btn btn-sm px-1 py-0 btn-outline-warning border-0',
      tooltip: 'Clone Reporting Group'
    },
    {
      data: 'deleteGroupKey',
      iconClass: 'fas fa-trash',
      hidden: false,
      buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
      tooltip: 'Delete Reporting Group'
    }
  ];
}

  ngOnInit(): void {
    this.state = 'ready';
    this.financialPlanningService.clearCurrentGroupKeySubscriptionValue();
  }

  addGroupKey() {
    this.showAddGroupKeyTable = true;
  }


  fpGroupClicked(rowColData: TableClickEvent<FPGroupRow>) {
    if (rowColData.button) {
      if (rowColData.button.data === 'editGroupKey') {
        this.currentGroupKeySelected = rowColData;
        this.financialPlanningService.setCurrentGroupKeySubscriptionValue(rowColData.row?.groupKey!);
      }
      else if(rowColData.button.data === 'cloneGroupKey') {
        this.currentGroupKeySelected = rowColData;
        this.cloneGroupKey.emit(rowColData);
      }
      else if(rowColData.button.data === 'deleteGroupKey') {
        this.currentGroupKeySelected = rowColData;
        this.deleteGroupKey.emit(rowColData);
      }
    }
  }

  getResults() {
    this.state = 'ready';
  }

  hideAddNewGroupKey() {
    this.showAddGroupKeyTable = false;
  }

  processFPTables() {
    if(confirm('Are you sure you want to process the ReportingGroups and ReportingNode tables ' +
               'on the Financial Planning Cube, THIS MAY TAKE SEVERAL MINUTES?')) {
                this.state = 'processing';
                this.financialPlanningService.processFpReportingTables()
                                             .subscribe(res => {
                                              this.state = 'ready';
                                                alert('Table processing complete!');
                                             }, err => {
                                                this.state = 'ready';
                                                alert('There was an error processing the tables on the Cube! ' + err.message);
                                             });
    }
  }

  saveNewGroupKey(newGroupKey: GroupKey) {
    // save the new groupkey
    this.financialPlanningService.postReportingGroup(newGroupKey.groupKey!, newGroupKey.name!)
                                 .subscribe(res => {
                                  this.hideAddNewGroupKey();
                                  this.refreshGroupKey.emit();
                                 }, err => {
                                  alert('Error saving new Group Key');
                                 });
  }

} // end component class

